/** Emissor DARF (SICALC via Integra Contador). */
import { Link, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Sec } from '../ui/layout';
import { EmissorDarf } from '../telas/integra/sicalc';
import { useIntegraAtivo } from '../telas/integra/cliente';

export const Route = createFileRoute('/_app/sicalc')({ validateSearch: z.object({ cliente: z.string().optional() }), component: Sicalc });

function Sicalc() {
  const s = Route.useSearch();
  const integra = useIntegraAtivo();
  return (
    <>
      <div className="topbar"><div><h1>Emissor DARF</h1><div className="sub">SICALC via Integra Contador — consolida multa e juros até a data de pagamento e gera o PDF{integra.ambiente === 'TRIAL' ? ' · ambiente de demonstração' : ''}</div></div></div>
      <div className="conteudo">
        {!integra.ativo ? <div className="alerta info">O Integra Contador está desligado. Um administrador liga em <Link to="/configuracoes">Configurações</Link>.</div> : (
          <Sec titulo="Novo DARF" sub="cada emissão é uma chamada cobrada pelo SERPRO (duas, com código de barras); o PDF entra em Documentos publicados do cliente">
            <EmissorDarf clienteIdInicial={s.cliente} />
          </Sec>
        )}
      </div>
    </>
  );
}
